import { Box, Grid } from '@mui/material';
/* eslint-disable max-len */
import { Fragment } from 'react';
import Title from '/@/components/title';
import { _ } from '/@/locale';
import RefugeLayoutOptions from '../layout-options';
import styles from './styles.module.css';

const CONTENTS = [
    {
        type: 'intro',
        crops: ['corn'],
        countries: ['BR', 'PY'],
        render: () => (
            <Fragment>
                <p>
                    {_(
                        'El refugio es muy importante dentro de las recomendaciones de buenas prácticas agronómicas y fundamental para asegurar la longevidad de las tecnologías Bt. Es el aprovechamiento de áreas con semillas no Bt cultivadas a una distancia máxima de 800 metros del cultivo con tecnología Bt.'
                    )}
                </p>
                <ul>
                    <li>
                        {_(
                            'Reserve al menos el 10% de su área para plantar maíz no Bt del mismo ciclo y tamaño que el maíz Bt.'
                        )}
                    </li>
                </ul>
            </Fragment>
        ),
    },
    {
        type: 'intro',
        crops: ['corn'],
        countries: ['UY', 'AR'],
        render: () => (
            <Fragment>
                <p>
                    {_(
                        'El refugio es una porción del lote sembrada, en la misma fecha, con un híbrido no Bt de similar ciclo de madurez que la del cultivo Bt. Es una herramienta clave para disminuir la presión de selección de resistencia de insectos a las proteínas Bt.'
                    )}
                </p>
                <p>
                    {_(
                        'El refugio funciona como reserva de insectos susceptibles, y permite que los insectos resistentes que pudieran sobrevivir sobre la porción Bt del lote, encuentren individuos susceptibles para cruzarse y generen descendencia susceptible, manteniendo baja la frecuencia de insectos resistentes. Si no hubiera refugio, los eventuales insectos resistentes seleccionados en el cultivo Bt se cruzarían entre ellos, aumentando rápidamente la frecuencia de insectos resistentes en la población.'
                    )}
                </p>
                <Grid container direction='column' sx={{ gap: 1 }}>
                    <Grid item sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                        <Box
                            sx={{
                                p: 0.5,
                                borderRadius: '50%',
                                background: (t) => t.palette.primary.main,
                            }}
                        />
                        <p>{_('10% de la superficie del lote sembrado con híbridos de tecnologia no Bt.')}</p>
                    </Grid>
                    <Grid item sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                        <Box
                            sx={{
                                p: 0.5,
                                borderRadius: '50%',
                                background: (t) => t.palette.primary.main,
                            }}
                        />
                        <p>{_('Sembrar híbridos de ciclo similar y con la misma fecha de siembra.')}</p>
                    </Grid>
                    <Grid item sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                        <Box
                            sx={{
                                p: 0.5,
                                borderRadius: '50%',
                                background: (t) => t.palette.primary.main,
                            }}
                        />
                        <p>
                            {' '}
                            {_(
                                'Insecticidas: según la plaga y según umbrales de daño. Diatrea: no aplicar. Spodoptera: aplicar según recomendación.'
                            )}
                        </p>
                    </Grid>
                </Grid>
            </Fragment>
        ),
    },
    {
        type: 'intro-catalog',
        crops: ['corn'],
        countries: ['UY', 'AR'],
        render: () => (
            <Fragment>
                <p>
                    {_(
                        'El objetivo del refugio es mantener una población de insectos susceptibles para que ocurran cruzamientos con los potenciales insectos resistentes de los lotes con cultivos Bt y produzcan descendencia susceptible.'
                    )}
                </p>
                <p className={styles.bold}>
                    {_(
                        'La mejor forma de preservar las tecnologías de cultivos con tolerancia a insectos es el refugio.'
                    )}
                </p>
                <p>
                    {_(
                        'La implementación del refugio es una de las principales acciones para el Manejo Integrado de Plagas (MIP), aunque su cumplimiento como herramienta única, no asegura la durabilidad de las tecnologías, sino que debemos complementarlo con el resto de las recomendaciones del MIP (rotación de cultivos, monitoreo, aplicación de insecticidas, etc.) para maximizar la eficacia y sustentabilidad del sistema productivo.'
                    )}
                </p>
            </Fragment>
        ),
    },
    {
        type: 'intro-catalog',
        crops: ['corn'],
        countries: ['BR', 'PY'],
        render: () => (
            <Fragment>
                <p>
                    {_(
                        'El refugio es muy importante dentro de las recomendaciones de buenas prácticas agronómicas y fundamental para asegurar la longevidad de las tecnologías Bt. Es el aprovechamiento de áreas con semillas no Bt cultivadas a una distancia máxima de 800 metros del cultivo con tecnología Bt.'
                    )}
                </p>
                <p>
                    {_(
                        'Reserve al menos el 10% de su área para plantar maíz no Bt del mismo ciclo y tamaño que el maíz Bt.'
                    )}
                </p>
            </Fragment>
        ),
    },
    {
        type: 'intro',
        crops: ['soy'],
        countries: ['BR', 'PY'],
        render: () => (
            <Fragment>
                <p>
                    {_(
                        'El refugio es muy importante dentro de las recomendaciones de buenas prácticas agronómicas y fundamental para asegurar la longevidad de las tecnologías Bt. Es el aprovechamiento de áreas con semillas no Bt cultivadas a una distancia máxima de 800 metros del cultivo con tecnología Bt.'
                    )}
                </p>
                <ul>
                    <li>{_('Reservar al menos el 20% del área sembrada con soja no Bt en el campo.')}</li>
                </ul>
            </Fragment>
        ),
    },
    {
        type: 'intro',
        crops: ['soy'],
        countries: ['AR', 'UY'],
        render: () => (
            <Fragment>
                <p>
                    {_(
                        'El refugio es una porción del lote sembrada, en la misma fecha, con una variedad no Bt de similar ciclo de madurez que la del cultivo Bt. Es una herramienta clave para disminuir la presión de selección de resistencia de insectos a las proteínas Bt.'
                    )}
                </p>
                <p>
                    {_(
                        'El refugio funciona como reserva de insectos susceptibles, y permite que los insectos resistentes que pudieran sobrevivir sobre la porción Bt del lote, encuentren individuos susceptibles para cruzarse y generen descendencia susceptible, manteniendo baja la frecuencia de insectos resistentes. Si no hubiera refugio, los eventuales insectos resistentes seleccionados en el cultivo Bt se cruzarían entre ellos, aumentando rápidamente la frecuencia de insectos resistentes en la población.'
                    )}
                </p>
                <ul>
                    <li>{_('20% de la superficie del lote sembrado con variedades de tecnologia no Bt.')}</li>
                    <li>{_('Sembrar variedades de ciclo similar y con la misma fecha de siembra.')}</li>
                </ul>
            </Fragment>
        ),
    },
    {
        type: 'extra',
        crops: ['corn'],
        countries: ['BR', 'PY'],
        render: () => (
            <Fragment>
                <Title color='light'>{_('Plagas objetivo de la tecnología VT PRO3®')}</Title>
                <ul>
                    <li>
                        {_('Larva alfinete')} <em>{_('(Diabrotica speciosa)')}</em>
                    </li>
                    <li>
                        {_('Gusano cogollero')} <em>{_('(Spodoptera Frugiperda)')}</em>
                    </li>
                    <li>
                        {_('Barrenador del tallo')} <em>{_('(Diatraea saccharalis)')}</em>
                    </li>
                    <li>
                        {_('Barrenado menor del tallo')} <em>{_('(Elasmopalpus lignosellus)')}</em>
                    </li>
                </ul>
            </Fragment>
        ),
    },
    {
        type: 'extra',
        crops: ['soy'],
        countries: ['BR', 'PY'],
        render: () => (
            <Fragment>
                <Title color='light'>{_('Plagas objetivo de la tecnología INTACTA RR2 PRO®')}</Title>
                <ul>
                    <li>
                        {_('Oruga de las leguminosas')} <em>{_('(Anticarsia gemmatalis)')}</em>
                    </li>
                    <li>
                        {_('Falsa Medidora ')} <em>{_('(Chrysodeixis includens)')}</em>
                    </li>
                    <li>
                        {_('Gusano cogollero')} <em>{_('(Chloridea virescens)')}</em>
                    </li>
                    <li>
                        {_('Barrenador del Brote')} <em>{_('(Crocidosema aporema)')}</em>
                    </li>
                </ul>
            </Fragment>
        ),
    },
    {
        type: 'extraBR',
        crops: ['soy'],
        countries: ['BR'],
        render: () => (
            <Fragment>
                <Title color='light'>{_('Plagas objetivo de la tecnología INTACTA 2 XTEND ')}</Title>
                <ul>
                    <li>
                        {_('Falsa Medidora ')} <em>{_('(Chrysodeixis includens)')}</em>
                    </li>
                    <li>
                        {_('Oruga de las leguminosas')} <em>{_('(Anticarsia gemmatalis)')}</em>
                    </li>
                    <li>
                        {_('Barrenador del Brote')} <em>{_('(Crocidosema aporema)')}</em>
                    </li>
                    <li>
                        {_('Gusano cogollero')} <em>{_('(Chloridea virescens)')}</em>
                    </li>
                    <li>{_('Helicoverpa armigera​')}</li>
                    <li>{_('Spodoptera cosmioides')}</li>
                </ul>
            </Fragment>
        ),
    },
    {
        type: 'layout-options',
        crops: ['soy'],
        countries: ['BR', 'PY'],
        render: (country) => <RefugeLayoutOptions crops='soy' countries={['BR', 'PY']} country={country} />,
    },
    {
        type: 'layout-options',
        crops: ['soy'],
        countries: ['AR', 'UY'],
        render: (country) => <RefugeLayoutOptions crops='soy' countries={['AR', 'UY']} country={country} />,
    },
    {
        type: 'rib-layout-options',
        crops: ['corn'],
        countries: ['AR'],
        render: (country) => <RefugeLayoutOptions crops='corn-rib' countries={['AR', 'UY']} country={country} />,
    },
    {
        type: 'good-practices',
        crops: ['corn', 'soy'],
        countries: ['BR', 'PY'],
        render: () => (
            <Fragment>
                <p> {_('Adopte buenas prácticas agronómicas y conserve la tecnología por mucho más tiempo.')}</p>
                <ol className={styles.goodPractices}>
                    <li>
                        <strong>
                            {_('Desecación temprana con seguimiento y manejo de plagas residentes en el rastrojo')}
                        </strong>
                        <p>
                            {_(
                                'La Desecación temprana de la cubierta vegetal tiene como objetivo proporcionar materia seca en el suelo, favoreciendo su protección y facilitando la operación de plantación. El momento óptimo de las aplicaciones de herbicidas puede variar según las condiciones climáticas y el sistema de plantación utilizado'
                            )}
                        </p>
                    </li>
                    <li>
                        <strong>{_('Tratamiento de semillas')}</strong>
                        <p>
                            {_(
                                'El tratamiento de semillas es una práctica que tiene como objetivo el control de plagas subterráneas y el inicio del cultivo, período de gran susceptibilidad a las plagas. Tratamiento de semillas El tratamiento de semillas es una práctica que tiene como objetivo el control de plagas subterráneas y el inicio del cultivo, período de gran susceptibilidad a las plagas.'
                            )}
                        </p>
                    </li>
                    <li>
                        <strong>{_('Plantar Refugio')}</strong>
                        <p>
                            {_(
                                'Las Áreas de Refugio Correctamente son áreas de cultivo que no cuentan con tecnología Bt. Sirven como proveedores de insectos susceptibles que se aparearán con insectos resistentes del área Bt. El resultado de este cruce serán insectos susceptibles y por lo tanto controlados por tecnología Bt. De esta manera, la susceptibilidad puede transmitirse a las generaciones futuras, asegurando la sostenibilidad de la eficacia del control.'
                            )}
                        </p>
                    </li>
                    <li>
                        <strong>{_('Manejo de malezas')}</strong>
                        <p>
                            {_(
                                'Algunas malezas pueden ser huéspedes importantes de plagas de insectos de cultivos posteriores, lo que permite que una cantidad significativa de insectos sobreviva en las áreas de cultivo fuera de temporada. Además, las maezs pueden ser una fuente de orugas en estadios más avanzados, que son más difíciles de controlar con tecnologías Bt.'
                            )}
                        </p>
                    </li>
                    <li>
                        <strong>{_('Monitoreo del cultivo en todas las etapas de desarrollo')}</strong>
                        <p>
                            {_(
                                'El Monitoreo de Plagas en el cultivo es fundamental en la toma de decisiones. Esta práctica identifica la situación de las plagas en el cultivo, evalúa los daños y pérdidas que puedan estar ocurriendo y define el momento de la aplicación del insecticida.'
                            )}
                        </p>
                    </li>
                    <li>
                        <strong>{_('Rotación de cultivos')}</strong>
                        <p>
                            {_(
                                'La Rotación de Cultivos consiste en alternar la siembra de diferentes especies de cultivos en una misma área agrícola. La elección de especies para este proceso debe tomar en cuenta factores económicos, plagas, enfermedades, fertilización, entre otros.'
                            )}
                        </p>
                    </li>
                </ol>
            </Fragment>
        ),
    },
    {
        type: 'good-practices',
        crops: ['corn', 'soy'],
        countries: ['AR', 'UY'],
        render: () => (
            <Fragment>
                <p>
                    {_(
                        'Los programas de Manejo de Resistencia de Insectos (MRI) son programas destinados a retrasar la evolución y selección de resistencia de insectos a las tecnologías Bt o a cualquier otra práctica de control. Se basan fundamentalmente en manejar, dentro del marco del Manejo Integrado de Plagas (MIP), los factores que favorecen la selección de resistencia para mantener muy baja la frecuencia de individuos resistentes a nivel del lote.'
                    )}
                </p>
                <p>
                    {_(
                        'Son un conjunto de BPA que incluyen rotación de cultivos, correcta elección de la tecnología con base en fecha de siembra y plaga principal, buen control de malezas y tratamiento de rastrojos (para evitar una población inicial de insectos elevada), siembra de refugio, buena implantación del cultivo (que puede mejorarse con el uso de semilla tratada), monitoreo periódico de plagas tanto en la porción de lote Bt como en el refugio y control de la plaga cuando se alcancen los umbrales recomendados.'
                    )}
                </p>
                <ol className={styles.goodPractices}>
                    <li>
                        <strong>{_('Barbecho')}</strong>
                        <p>
                            {_(
                                'La preparación del lote antes de la siembra es de fundamental importancia en un programa de MRI. Larvas grandes provenientes de malezas y rastrojos pueden migrar al cultivo Bt y causarle daños sin llegar a ser controladas totalmente por la tecnología.'
                            )}
                        </p>
                    </li>
                    <li>
                        <strong>{_('Siembra correcta de Refugio')}</strong>
                        <p>
                            {_(
                                'Para proveer adultos susceptibles que puedan cruzarse con los resistentes generados en la porción Bt del lote. La descendencia de estos cruzamientos es controlada por la tecnología.'
                            )}
                        </p>
                        <p>
                            {_(
                                'Implantación del cultivo: Una buena implantación se refiere a tener la cantidad de plantas por hectárea adecuada y en óptimas condiciones sanitarias. La implantación rápida y vigorosa del cultivo, tanto de la porción Bt como del refugio dentro del lote, da como resultado cultivos uniformes temporal y espacialmente. Para lograr un cultivo uniforme es clave asegurarse que tanto la humedad como la temperatura del suelo sean óptimas para la germinación y deben protegerse las semillas y/o las plántulas en sus primeros estadios mediante un adecuado tratamiento de semillas.'
                            )}
                        </p>
                        <p>
                            {_(
                                'Monitoreo y control: Monitorear el cultivo durante todo el ciclo para conocer la incidencia y severidad del ataque de todas las plagas y aplicar insecticidas, u otras estrategias de control, cuando el daño alcance un umbral pre-establecido para cada plaga/cultivo, tanto en el refugio como en el cultivo Bt. El monitoreo es clave para detectar daños inesperados en forma temprana e iniciar un programa de contención de dispersión del posible foco de resistencia.'
                            )}
                        </p>
                    </li>
                    <li>
                        <strong>{_('Rotación de cultivos')}</strong>
                        <p>{_('La rotación de cultivos es importante para:')}</p>
                        <ul>
                            <li>
                                {_(
                                    'Reducir la población de insectos plaga, ya que los insectos plaga de un cultivo generalmente son distintos de los insectos plaga que afectan al siguiente cultivo en la rotación.'
                                )}
                            </li>
                            <li>
                                {_(
                                    'Mejorar el control de insectos y malezas al poder rotar modos de acción de insecticidas y herbicidas.'
                                )}
                            </li>
                            <li>
                                {_(
                                    'Mantener las propiedades físico-químicas del suelo, que favorecerán la buena implantación y estado general de los cultivos.'
                                )}
                            </li>
                        </ul>
                    </li>
                </ol>
            </Fragment>
        ),
    },
    {
        type: 'layout-options',
        crops: ['corn'],
        countries: ['BR', 'PY'],
        render: (country) => <RefugeLayoutOptions crops='corn' countries={['BR', 'PY']} country={country} />,
    },
    {
        type: 'layout-options',
        crops: ['corn'],
        countries: ['AR', 'UY'],
        render: (country) => <RefugeLayoutOptions crops='corn' countries={['AR', 'UY']} country={country} />,
    },
];

export const getStaticContent = (type, crop, country) => {
    return CONTENTS.find(
        (content) => content.type === type && content.crops.includes(crop) && content.countries.includes(country)
    );
};
